import { useEffect } from 'react';

const SITE = 'A3GS Tec';
const DEFAULT_URL = import.meta.env.VITE_SITE_URL || 'https://v2.a3gs.com.br';

type SeoProps = {
  title: string;
  description: string;
  path?: string;
  noIndex?: boolean;
};

function upsertMeta(name: string, content: string) {
  let node = document.head.querySelector(`meta[name="${name}"]`);
  if (!node) {
    node = document.createElement('meta');
    node.setAttribute('name', name);
    document.head.appendChild(node);
  }
  node.setAttribute('content', content);
}

function upsertProperty(property: string, content: string) {
  let node = document.head.querySelector(`meta[property="${property}"]`);
  if (!node) {
    node = document.createElement('meta');
    node.setAttribute('property', property);
    document.head.appendChild(node);
  }
  node.setAttribute('content', content);
}

export function Seo({ title, description, path = '/', noIndex = false }: SeoProps) {
  useEffect(() => {
    const fullTitle = title === SITE ? title : `${title} | ${SITE}`;
    const canonicalUrl = new URL(path, DEFAULT_URL).toString();
    document.title = fullTitle;
    upsertMeta('description', description);
    upsertMeta('robots', noIndex ? 'noindex,nofollow,noarchive' : 'index,follow');
    upsertProperty('og:title', fullTitle);
    upsertProperty('og:description', description);
    upsertProperty('og:type', 'website');
    upsertProperty('og:url', canonicalUrl);
    upsertProperty('og:image', new URL('/assets/logo-a3gs.png', DEFAULT_URL).toString());
    upsertMeta('twitter:card', 'summary');
    upsertMeta('twitter:title', fullTitle);
    upsertMeta('twitter:description', description);

    let link = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = canonicalUrl;
  }, [title, description, path, noIndex]);

  return null;
}
